'use strict';

var React = require('react'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    Icon = require('../atoms/Icon'),
    getThumbnailUrl = require('../utils/getThumbnailUrl'),
    DraftActionCreators = require('../actions/DraftActionCreators'),
    ContentEditable = require('../atoms/ContentEditable'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    DragItemTypes = require('../constants/DragItemTypes'),
    ImageSizes = require('../constants/ImageSizes'),
    createFlexibleImageQueueMixin = require('../mixins/createFlexibleImageQueueMixin'),
    { DragDropMixin, ImagePreloaderMixin, DropEffects } = require('react-dnd'),
    { PropTypes } = React;

require('./legacy/Section.less');

var EditorCover = React.createClass({
  mixins: [ClassNameMixin, PureRenderMixin, DragDropMixin, ImagePreloaderMixin, createFlexibleImageQueueMixin(1)],

  className: 'editor-Section editor-Section--cover',

  propTypes: {
    uuid: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    background: PropTypes.object
  },

  getImageOptions() {
    return {
      image: this.props.background,
      mode: 'scale_crop',
      sizes: {
        thumb: true,
        normal: true,
        retina: window.devicePixelRatio > 1.5
      }
    };
  },

  getBackgroundDragPreviewUrl() {
    if (!this.props.background) {
      return;
    }

    var background = this.props.background,
        scale = this.getDragImageScale();

    return getThumbnailUrl(background, {
      mode: 'preview',
      width: Math.round(ImageSizes.EDITOR_COVER_DRAG.width * scale),
      height: Math.round(ImageSizes.EDITOR_COVER_DRAG.height * scale)
    });
  },

  getImageUrlsToPreload() {
    return [this.getBackgroundDragPreviewUrl()];
  },

  configureDragDrop(registerType) {
    registerType(DragItemTypes.IMAGE, {
      dragSource: {
        canDrag() {
          return this.props.background &&
                 this.hasPreloadedImage(this.getBackgroundDragPreviewUrl());
        },

        beginDrag() {
          return {
            effectsAllowed: [DropEffects.MOVE],
            dragPreview: this.getPreloadedImage(this.getBackgroundDragPreviewUrl()),
            item: {
              image: this.props.background
            }
          };
        },

        endDrag(dropEffect) {
          if (dropEffect === DropEffects.MOVE && this.props.background !== null) {
            DraftActionCreators.updateSection(this.props.uuid, {
              background: null
            });
          }
        }
      },

      dropTarget: {
        acceptDrop(item) {
          if (this.props.background !== item.image) {
            DraftActionCreators.updateSection(this.props.uuid, {
              background: item.image
            });
          }
        }
      }
    });
  },

  componentDidUpdate(prevProps) {
    if (prevProps.background !== this.props.background) {
      this.updateImageQueue();
    }
  },

  render() {
    var backgroundStyle = {},
        dropImageState = this.getDropState(DragItemTypes.IMAGE),
        dragImageState = this.getDragState(DragItemTypes.IMAGE),
        showBackground = this.props.background && !dragImageState.isDragging,
        dragSource = this.state.isBackgroundDraggingDisabled ? {} : this.dragSourceFor(DragItemTypes.IMAGE);

    if (showBackground) {
      backgroundStyle.backgroundImage = this.getBackgroundImageUrl();
    }

    return (
      <div className={this.getClassName()}
           data-state={showBackground ? 'background' : 'empty'}
           data-hint={dropImageState.isDragging}
           data-hover={dropImageState.isHovering}
           {...this.dropTargetFor(DragItemTypes.IMAGE)}
           {...dragSource}>

        {this.renderLoaderImg()}

        <div className='editor-Section-topBar'>
          <div className='editor-Section-type'>
            <Icon name='poster' size='small' mode='stroke' />
            <span className='editor-Section-typeTitle'>Cover</span>
          </div>
        </div>

        <div className='editor-SectionHint'>
          <div className='editor-SectionHint-box'>
            <Icon name='image' size='medium' mode='stroke' />
            <p className='editor-SectionHint-message utils--smallCaps'></p>
          </div>
        </div>

        {showBackground &&
          <div className='editor-Section-background'
               style={backgroundStyle}
               {...dragSource}>
          </div>
        }

        <div className='editor-Section-wrapperBox'>
          {showBackground &&
            <div className='editor-Section-deleteBackground'
                 title='Remove background image'>
              <Icon name='cross' size='xsmall' mode='stroke' onClick={this.removeBackground} />
            </div>
          }

          <div className='editor-Section-hgroup'>
            <ContentEditable className='editor-Section-title'
                             component='h1'
                             placeholder='Title'
                             text={this.props.title}
                             onChange={this.handleTitleChange}
                             maxLength={80}
                             editable
                             onMouseEnter={this.handleEditableEnter}
                             onMouseLeave={this.handleEditableLeave} />
            <ContentEditable className='editor-Section-subtitle'
                             component='h2'
                             placeholder='Subtitle (optional)'
                             text={this.props.subtitle}
                             onChange={this.handleSubtitleChange}
                             maxLength={140}
                             editable
                             onMouseEnter={this.handleEditableEnter}
                             onMouseLeave={this.handleEditableLeave} />
          </div>
        </div>
      </div>
    );
  },

  handleEditableEnter() {
    // This fix removes conflict between contentEditable and draggable elements in some browsers
    // (I'm not pointing fingers but it was IE)
    // Without this fix, draggable element can prevent focusing in contentEditable.

    this.setState({ isBackgroundDraggingDisabled: true });
  },

  handleEditableLeave() {
    this.setState({ isBackgroundDraggingDisabled: false });
  },

  handleTitleChange(textContent) {
    if (this.props.title === textContent) {
      return;
    }

    DraftActionCreators.updateSection(this.props.uuid, {
      title: textContent
    });
  },

  handleSubtitleChange(textContent) {
    if (this.props.subtitle === textContent) {
      return;
    }

    DraftActionCreators.updateSection(this.props.uuid, {
      subtitle: textContent
    });
  },

  removeBackground() {
    if (this.props.background === null) {
      return;
    }

    DraftActionCreators.updateSection(this.props.uuid, {
      background: null
    });
  }
});

module.exports = EditorCover;



/** WEBPACK FOOTER **
 ** ./editor/EditorCover.jsx
 **/